export default {
  fr: require('./fr.json'),
  en: require('./en.json'),
  jp: require('./jp.json')
}
